import React from 'react';
import '../styles/AppLoader.css'; 

const AppLoader = () => {
  return (
    <div className="custom-loader-overlay">
      <div className="custom-spinner"></div>
    
    </div>
  );
};

export default AppLoader;